module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/contact_us_2.f05511f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/contact_us/contact_us_2.png
// module id = djgB
// module chunks = 3